import React, { Fragment, useState } from "react";
import "./App.css";

import analytics from "./analytics";

// Components
import MenuBar from "./Components/MenuBar";
import ParametersTab from "./Components/Parameters";
import Resources from "./Components/Resources";

import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Paper,
  Tab,
  Typography,
} from "@mui/material";

// Material ui icons
import AutorenewIcon from "@mui/icons-material/Autorenew";
import FreeBreakfastIcon from "@mui/icons-material/FreeBreakfast";
import TwitterIcon from "@mui/icons-material/Twitter";
import WineBarIcon from "@mui/icons-material/WineBar";

import { TabContext, TabList, TabPanel } from "@mui/lab";

// YML files
import Parameters from "./yml/Parameters.yml";
import Conditions from "./yml/Conditions.yml";
import AnalyticsBucket from "./yml/AnalyticsBucket.yml";
import AppBucket from "./yml/AppBucket.yml";
import AppBucketWWW from "./yml/AppBucketWWW.yml";
import DeploymentBucket from "./yml/DeploymentBucket.yml";
import LandingPageBucket from "./yml/LandingPageBucket.yml";
import LandingPageBucketWWW from "./yml/LandingPageBucketWWW.yml";
import PublicFilesBucket from "./yml/PublicFilesBucket.yml";
import UserUploadBucket from "./yml/UserUploadBucket.yml";
import CloudFrontApp from "./yml/CloudFrontApp.yml";
import CloudFrontAppWWW from "./yml/CloudFrontAppWWW.yml";
import CloudFrontPublicFiles from "./yml/CloudFrontPublicFiles.yml";
import CloudFrontLandingPage from "./yml/CloudFrontLandingPage.yml";
import CloudFrontLandingPageWWW from "./yml/CloudFrontLandingPageWWW.yml";
import UserPoolApp from "./yml/UserPoolApp.yml";
import IdentityPoolLandingPage from "./yml/IdentityPoolLandingPage.yml";
import mainDynamoTable from "./yml/mainDynamoTable.yml";

var fileDownload = require("js-file-download");

function App() {
  const [value, setValue] = useState("0");

  const [isLoading, setIsLoading] = useState(false);

  const [inputParameters, setInputParameters] = useState({
    awsProfile: "",
    domainName: "",
    projectName: "",
    projectShortName: "",
    idx: (Math.random() + 1).toString(36).substring(7),
  });

  const resourceYML = {
    AnalyticsBucket: AnalyticsBucket,
    AppBucket: AppBucket,
    AppBucketWWW: AppBucketWWW,
    DeploymentBucket: DeploymentBucket,
    LandingPageBucket: LandingPageBucket,
    LandingPageBucketWWW: LandingPageBucketWWW,
    PublicFilesBucket: PublicFilesBucket,
    UserUploadBucket: UserUploadBucket,
    CloudFrontApp: CloudFrontApp,
    CloudFrontAppWWW: CloudFrontAppWWW,
    CloudFrontPublicFiles: CloudFrontPublicFiles,
    CloudFrontLandingPage: CloudFrontLandingPage,
    CloudFrontLandingPageWWW: CloudFrontLandingPageWWW,
    UserPoolApp: UserPoolApp,
    IdentityPoolLandingPage: IdentityPoolLandingPage,
    mainDynamoTable: mainDynamoTable,
    Parameters: Parameters,
    Conditions: Conditions,
  };
  const data = [
    {
      type: "s3",
      name: "AnalyticsBucket",
      checked: false,
      label: "Analytics bucket",
    },
    {
      type: "s3",
      name: "AppBucket",
      checked: false,
      label: "App bucket",
    },
    {
      type: "s3",
      name: "AppBucketWWW",
      checked: false,
      label: "App bucket www",
    },
    {
      type: "s3",
      name: "DeploymentBucket",
      checked: false,
      label: "Deployment bucket",
    },
    {
      type: "s3",
      name: "LandingPageBucket",
      checked: false,
      label: "Landing page bucket",
    },
    {
      type: "s3",
      name: "LandingPageBucketWWW",
      checked: false,
      label: "Landing page bucket www",
    },
    {
      type: "s3",
      name: "PublicFilesBucket",
      checked: false,
      label: "Public files bucket",
    },
    {
      type: "s3",
      name: "UserUploadBucket",
      checked: false,
      label: "User upload bucket",
    },
    {
      type: "cloudfront",
      name: "CloudFrontApp",
      checked: false,
      label: "Cloudfront app",
    },
    {
      type: "cloudfront",
      name: "CloudFrontAppWWW",
      checked: false,
      label: "Cloudfront app www",
    },
    {
      type: "cloudfront",
      name: "CloudFrontPublicFiles",
      checked: false,
      label: "Cloudfront public files",
    },
    {
      type: "cloudfront",
      name: "CloudFrontLandingPage",
      checked: false,
      label: "Cloudfront landing page",
    },
    {
      type: "cloudfront",
      name: "CloudFrontLandingPageWWW",
      checked: false,
      label: "Cloudfront landing page www",
    },
    {
      type: "cognito",
      name: "UserPoolApp",
      checked: false,
      label: "User pool app",
    },
    {
      type: "cognito",
      name: "IdentityPoolLandingPage",
      checked: false,
      label: "Identity pool landing page",
    },
    {
      type: "dynamodb",
      name: "mainDynamoTable",
      checked: false,
      label: "DynamoDB table app",
    },
  ];

  const [resources, setResources] = useState(data);

  const handleResourcePick = (event, index) => {
    setResources((current) =>
      current.map((obj, ids) => {
        if (ids === index) {
          return { ...obj, checked: event.target.checked };
        }
        return obj;
      })
    );
  };

  async function handleSubmit() {
    setIsLoading(true);
    let ymlData = "";

    // Read the parameters
    let tempParameters = await fetch(Parameters);
    tempParameters = await tempParameters.text();

    // Read the conditions
    let tempConditions = await fetch(Conditions);
    tempConditions = await tempConditions.text();

    const { awsProfile, domainName, idx, projectName, projectShortName } =
      inputParameters;

    // Replace the keywords
    tempParameters = tempParameters.replace(
      "a_domain",
      domainName.toLowerCase()
    );
    tempParameters = tempParameters.replace(
      "b_domain",
      `www.${domainName.toLowerCase()}`
    );
    tempParameters = tempParameters.replace(
      "c_domain",
      `app.${domainName.toLowerCase()}`
    );
    tempParameters = tempParameters.replace(
      "d_domain",
      `www.app.${domainName.toLowerCase()}`
    );
    tempParameters = tempParameters.replace("a_idx", idx.toLowerCase());
    tempParameters = tempParameters.replace(
      "a_project_name",
      projectName.toLowerCase()
    );
    tempParameters = tempParameters.replace(
      "b_project_short_name",
      projectShortName.toLowerCase()
    );

    // Combine
    ymlData += `${tempParameters} \n\n${tempConditions}`;

    // Add resources
    ymlData += `\n\nResources:\n`;

    for (let i in resources) {
      console.log("resource: ", i);

      if (resources[i].checked) {
        //  Read file
        let yml = await fetch(resourceYML[resources[i].name]);

        // Wait for promise
        yml = await yml.text();

        // Combine with prev data
        ymlData += `\n${yml}\n\n`;
      }
    }

    // Create json with data
    const jsonData = {
      aws_profile: awsProfile,
      app_description:
        projectName.charAt(0).toUpperCase() + projectName.slice(1),
      domain_name: domainName,
      project_name: projectName.charAt(0).toUpperCase() + projectName.slice(1),
      project_name_short: projectShortName,
      resource_id: idx,
    };

    fileDownload(
      ymlData,
      `${projectName.toLowerCase().replaceAll(" ", "_")}.yml`
    );

    setTimeout(() => {
      fileDownload(
        JSON.stringify(jsonData),
        `${projectName.toLowerCase().replaceAll(" ", "_")}.json`
      );
    }, "500")
    

    setIsLoading(false);

    analytics.track("new download");
  }

  const handleParameterChange = (prop) => (event) => {
    setInputParameters({ ...inputParameters, [prop]: event.target.value });
  };

  return (
    <Fragment>
      <MenuBar />
      <Container sx={{ p: 4 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={7}>
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={(event, newValue) => {
                      setValue(newValue);
                    }}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="lab API tabs example"
                  >
                    <Tab label="Parameters" value="0" />
                    <Tab label="S3" value="1" />
                    <Tab label="Cloudfront" value="2" />
                    <Tab label="Cognito" value="3" />
                    <Tab label="DynamoDB" value="4" />
                  </TabList>
                </Box>
                <TabPanel value="0">
                  <ParametersTab
                    data={{
                      inputParameters,
                      handleParameterChange,
                      setInputParameters,
                    }}
                  />
                </TabPanel>
                <TabPanel value="1">
                  S3 buckets for storage
                  <Resources
                    resources={resources}
                    onChange={handleResourcePick}
                    type="s3"
                  />
                </TabPanel>
                <TabPanel value="2">
                  Cloudfront
                  <Resources
                    resources={resources}
                    onChange={handleResourcePick}
                    type="cloudfront"
                  />
                </TabPanel>
                <TabPanel value="3">
                  Cognito
                  <Resources
                    resources={resources}
                    onChange={handleResourcePick}
                    type="cognito"
                  />
                </TabPanel>
                <TabPanel value="4">
                  DynamoDB
                  <Resources
                    resources={resources}
                    onChange={handleResourcePick}
                    type="dynamodb"
                  />
                </TabPanel>
              </TabContext>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Paper
              sx={{
                boxShadow: "none",
                border: "1px solid",
                p: "20px 20px 20px 20px",
              }}
            >
              <Typography variant="h6" sx={{ mb: 2 }}>
                Chosen resources
              </Typography>
              {Object.entries(resources).map(
                ([key, value], index) =>
                  value.checked && (
                    <Typography key={Math.random()}>- {value.label}</Typography>
                  )
              )}
            </Paper>
          </Grid>
        </Grid>

        <Grid container sx={{ mt: 2 }}>
          <Grid item xs={12} md={7}>
            <Button
              disableElevation
              variant="contained"
              onClick={handleSubmit}
              fullWidth
              startIcon={
                isLoading && (
                  <AutorenewIcon
                    sx={{
                      animation: "spin 2s linear infinite",
                      "@keyframes spin": {
                        "0%": {
                          transform: "rotate(0deg)",
                        },
                        "100%": {
                          transform: "rotate(360deg)",
                        },
                      },
                    }}
                  />
                )
              }
            >
              Download Cloudformation YML
            </Button>
          </Grid>
        </Grid>
        <Grid container sx={{ mt: 4 }}>
          <Grid item xs={12} md={6}>
            <Typography
              sx={{ "&:hover": { cursor: "pointer" } }}
              onClick={(e) => {
                e.preventDefault();
                analytics.track("new coffee visitor");
                window.open(
                  "https://www.buymeacoffee.com/norahsakal",
                  "_blank"
                );
              }}
            >
              Find this tool useful? Buy me a coffee{" "}
              <IconButton aria-label="coffee">
                <FreeBreakfastIcon />
              </IconButton>
              or a mimosa{" "}
              <IconButton aria-label="mimosa">
                <WineBarIcon />
              </IconButton>
            </Typography>
            <Typography>
              Built by @norahsakal{" "}
              <IconButton aria-label="twitter" onClick={(e) => {
                e.preventDefault();
                analytics.track("new twitter visitor");
                window.open(
                  "https://twitter.com/norahsakal",
                  "_blank"
                );
              }}>
                <TwitterIcon />
              </IconButton>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
}

export default App;
